import {useQueryParams, useRouteEntities} from '@aboutyou/router';

import {ProductTileEntities} from '../ProductTile/types';

export const useSizeIdFromStateOrParams = () => {
  const params = useQueryParams();

  const queryParamVid = params.get('vid');
  const {selectedSizeId} =
    useRouteEntities<ProductTileEntities>() as ProductTileEntities;

  return queryParamVid || selectedSizeId;
};
